import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {first, map} from "rxjs/operators";
import {List} from "immutable";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";

@Injectable()
export class CountryCodesFetchService {

	constructor(private endpoints: EndpointsProvider) {
	}

	fetchCountryCodes(): Observable<string[]> {
		return this.endpoints.assets.getCountryCodes()
			.pipe(
				first(),
				map(value => List(value.split(','))),
				map(value => value.map(str => str.trim()).toArray())
			);
	}
}
